// Name, avatar, and voice bundled together as one persona — picking a face
// can't accidentally leave a mismatched name or voice attached to it.
// Voice IDs pulled live from the account's actual voice library (the old
// hardcoded list had drifted: ElevenLabs had renamed/reassigned several of
// these IDs since they were first chosen, so the labels no longer matched
// reality). Shared between Branding (change anytime) and Signup (set once).
export const PERSONAS = [
  { name: 'Ava', file: 'ava-avatar.png', voiceId: 'R5inFyOky147t6GrSrut', voiceLabel: 'Ava (custom)' },
  { name: 'Maya', file: 'maya-avatar.png', voiceId: 'cgSgspJ2msm6clMCkdW9', voiceLabel: 'Jessica' },
  { name: 'Nina', file: 'nina-avatar.png', voiceId: 'pFZP5JQG7iQjIQuC4Bku', voiceLabel: 'Lily' },
  { name: 'Ella', file: 'ella-avatar.png', voiceId: 'XrExE9yKIg1WjnnlVkGX', voiceLabel: 'Matilda' },
  { name: 'Daniel', file: 'daniel-avatar.png', voiceId: 'onwK4e9ZLuTAKqWW03F9', voiceLabel: 'Daniel' },
  { name: 'Leo', file: 'leo-avatar.png', voiceId: 'nPczCjzI2devNBz1zQrb', voiceLabel: 'Brian' },
];

// For the "customize voice" override only — current, verified names/IDs
// from the account's real voice library (see PERSONAS comment above).
export const VOICE_OPTIONS = [
  { id: '', label: 'Default voice' },
  { id: 'R5inFyOky147t6GrSrut', label: 'Ava (custom)' },
  { id: 'cgSgspJ2msm6clMCkdW9', label: 'Jessica' },
  { id: 'Xb7hH8MSUJpSbSDYk0k2', label: 'Alice' },
  { id: 'ZSNL4hPqCnqoMPaI4jGX', label: 'Hannah' },
  { id: 'XrExE9yKIg1WjnnlVkGX', label: 'Matilda' },
  { id: 'pFZP5JQG7iQjIQuC4Bku', label: 'Lily' },
  { id: 'onwK4e9ZLuTAKqWW03F9', label: 'Daniel' },
  { id: 'cjVigY5qzO86Huf0OWal', label: 'Eric' },
  { id: 'pNInz6obpgDQGcFmaJgB', label: 'Adam' },
  { id: 'nPczCjzI2devNBz1zQrb', label: 'Brian' },
];
